import { jsx as _jsx } from "react/jsx-runtime";

function SvgOrder() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.236 3a1 1 0 00-.894.553L3.618 7h16.764l-1.724-3.447A1 1 0 0017.764 3H13v2a1 1 0 11-2 0V3H6.236zM21 9h-4v2a2 2 0 01-2 2H9a2 2 0 01-2-2V9H3v11a1 1 0 001 1h16a1 1 0 001-1V9zM9 9v2h6V9H9zm8.764-8H6.236a3 3 0 00-2.683 1.658L1.21 7.342A2 2 0 001 8.236V20a3 3 0 003 3h16a3 3 0 003-3V8.236a2 2 0 00-.211-.894l-2.342-4.684A3 3 0 0017.764 1z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgOrder;